const data = [
  {
    id: 1,
    title: "Leadership nel mondo digitale",
    body:
      "La leadership nel mondo digitale richiede la capacità di navigare in un ambiente in rapida evoluzione, motivare i team in un contesto remoto e utilizzare la tecnologia per ottenere risultati.",
  },
  {
    id: 2,
    title: "La comunicazione efficace",
    body:
      "La comunicazione efficace è un pilastro fondamentale per la leadership. Un leader deve saper comunicare chiaramente, ascoltare attivamente e risolvere conflitti con diplomazia.",
  },
  {
    id: 3,
    title: "La visione a lungo termine",
    body:
      "Un leader deve avere una visione a lungo termine per la sua organizzazione, capacità di anticipare i cambiamenti e guidare il team verso il successo.",
  },
  {
    id: 4,
    title: "La motivazione del team",
    body:
      "Un leader deve essere in grado di motivare il proprio team, ispirare passione e dedizione e creare un ambiente di lavoro positivo e collaborativo.",
  },
  {
    id: 5,
    title: "La capacità di prendere decisioni",
    body:
      "La capacità di prendere decisioni rapide e informate è una competenza critica per un leader. Un leader deve essere in grado di valutare tutti i fattori e prendere decisioni che siano giuste per l'organizzazione.",
  },
];

export default data;
